interface Props {
  // In SQL database, from table ApplicationDefinition, config value can have a few use cases:
  // - no "AppEnv" field (equal C# `null` value)
  // - "AppEnv" field value as `null`. Yes, `null` is a valid JSON data type, but NOT `undefined` which will cause an error.
  // - "AppEnv" field value "" (empty string),
  // But on UI there is no requirement to render this component when appEnv value is null or empty string.
  value: string;
}

export function AppEnv(props: Readonly<Props>) {
  const { value } = props;

  let classNames =
    "flex h-[16px] w-max items-center justify-center rounded-sm border border-4 text-[12px] leading-[16px] font-bold tracking-wide text-white uppercase";

  if (value) {
    classNames += " bg-black border-black";
  } else {
    classNames += " bg-transparent";
  }

  return (
    <div data-testid="app-env-container" className={classNames}>
      <span data-testid="app-env-value" className="relative top-[1px]">
        {value}
      </span>
    </div>
  );
}
